import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LangProvider } from "./lib/i18n";
import { AppProvider } from "./context/AppContext";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Agenda from "./pages/Agenda";
import Clients from "./pages/Clients";
import ClientProfile from "./pages/ClientProfile";
import Services from "./pages/Services";
import Locations from "./pages/Locations";
import Staff from "./pages/Staff";
import Consents from "./pages/Consents";
import Revenue from "./pages/Revenue";
import Invoices from "./pages/Invoices";
import Reports from "./pages/Reports";
import SettingsPage from "./pages/Settings";
import Book from "./pages/public/Book";
import Billing from "./pages/Billing";
import Platform from "./pages/Platform";
import Portal from "./pages/portal/Portal";
import PatientStart from "./pages/portal/PatientStart";
import Shop from "./pages/Shop";
import ShopFront from "./pages/public/ShopFront";
import Content from "./pages/Content";
import { BlogPage, ReviewsPage, Unsubscribe } from "./pages/public/ContentPublic";
import PaymentResult from "./pages/public/PaymentResult";
import ConsentSign from "./pages/public/ConsentSign";
import ManageBooking from "./pages/public/ManageBooking";
import PayLink from "./pages/public/PayLink";
import ChatPage from "./pages/public/ChatWidget";
import Join from "./pages/public/Join";
import Waitlist from "./pages/public/Waitlist";
import Inbox from "./pages/Inbox";
import Marketing from "./pages/Marketing";
import Forms from "./pages/Forms";
import PassportView from "./pages/public/PassportView";
import HomeBook from "./pages/public/HomeBook";
import JoinTeam from "./pages/public/JoinTeam";
import HomeVisits from "./pages/HomeVisits";
import JobOffer from "./pages/public/JobOffer";
import Earnings from "./pages/Earnings";
import Packages from "./pages/Packages";
import PackagesShop from "./pages/public/PackagesShop";
import ClinicHome from "./pages/public/ClinicHome";
import Availability from "./pages/Availability";
import HealthForm from "./pages/public/HealthForm";
import CheckIn from "./pages/CheckIn";
import SupplierOrder from "./pages/public/SupplierOrder";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/book/:slug" element={<Book />} />
            <Route path="/p/:slug" element={<Portal />} />
            <Route path="/patient" element={<PatientStart />} />
            <Route path="/chat/:slug" element={<ChatPage />} />
            <Route path="/join/:slug" element={<Join />} />
            <Route path="/waitlist/:slug" element={<Waitlist />} />
            <Route path="/passport/:token" element={<PassportView />} />
            <Route path="/home/:slug" element={<HomeBook />} />
            <Route path="/join-team/:slug" element={<JoinTeam />} />
            <Route path="/job/:token" element={<JobOffer />} />
            <Route path="/shop/:slug" element={<ShopFront />} />
            <Route path="/packages/:slug" element={<PackagesShop />} />
            <Route path="/c/:slug" element={<ClinicHome />} />
            <Route path="/blog/:slug" element={<BlogPage />} />
            <Route path="/blog/:slug/:post" element={<BlogPage />} />
            <Route path="/reviews/:slug" element={<ReviewsPage />} />
            <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
            <Route path="/payment/success" element={<PaymentResult />} />
            <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            <Route path="/consent/:token" element={<ConsentSign />} />
            <Route path="/health/:token" element={<HealthForm />} />
            <Route path="/supplier-order/:token" element={<SupplierOrder />} />
            <Route path="/manage/:token" element={<ManageBooking />} />
            <Route path="/pay/:token" element={<PayLink />} />
            <Route path="/*" element={
              <AppProvider>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/login/:slug" element={<Login />} />
                  <Route path="/signup" element={<Navigate to="/login?contact=1" replace />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/checkin/:cid" element={<CheckIn />} />
                  <Route path="/app" element={<AppShell />}>
                    <Route index element={<Dashboard />} />
                    <Route path="agenda" element={<Agenda />} />
                    <Route path="availability" element={<Availability />} />
                    <Route path="clients" element={<Clients />} />
                    <Route path="clients/:id" element={<ClientProfile />} />
                    <Route path="services" element={<Services />} />
                    <Route path="locations" element={<Locations />} />
                    <Route path="staff" element={<Staff />} />
                    <Route path="consents" element={<Consents />} />
                    <Route path="revenue" element={<Revenue />} />
                    <Route path="invoices" element={<Invoices />} />
                    <Route path="reports" element={<Reports />} />
                    <Route path="settings" element={<SettingsPage />} />
                    <Route path="billing" element={<Billing />} />
                    <Route path="shop" element={<Shop />} />
                    <Route path="content" element={<Content />} />
                    <Route path="inbox" element={<Inbox />} />
                    <Route path="marketing" element={<Marketing />} />
                    <Route path="forms" element={<Forms />} />
                    <Route path="home-visits" element={<HomeVisits />} />
                    <Route path="earnings" element={<Earnings />} />
                    <Route path="packages" element={<Packages />} />
                    <Route path="platform" element={<Platform />} />
                  </Route>
                  <Route path="*" element={<Navigate to="/app" replace />} />
                </Routes>
              </AppProvider>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </LangProvider>
    </div>
  );
}

export default App;
